import { processSteps } from "@/mocks/collections";
import Reveal from "@/components/base/Reveal";

export default function ProcessSection() {
  return (
    <section
      id="process"
      className="relative w-full bg-[#e6f0ff] border-t border-[var(--lum-gold)]/12 py-24 md:py-32 px-6 md:px-12"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 md:mb-20">
          <Reveal className="lg:col-span-7">
            <div className="font-label text-[11px] text-[var(--lum-gold)] mb-5">
              放課後の時間割 / 当日の流れ
            </div>
            <h4 className="font-jp text-5xl md:text-6xl lg:text-[64px] leading-[1.2] text-[var(--lum-cream)] font-medium">
              <a href="#process" className="cursor-pointer lum-underline">
                20時に集まって、<br />
                何をするのか。
              </a>
            </h4>
          </Reveal>
          <Reveal className="lg:col-span-5 flex items-end" delay={1}>
            <p className="font-jp text-base md:text-lg text-[var(--lum-cream)]/65 leading-[2.0]">
              ゆるく、でも確実に。毎回同じ流れで進みます。初めての方でも、来てから「どうしよう」と思うことはありません。
            </p>
          </Reveal>
        </div>

        <div className="relative">
          {/* Connecting line on desktop */}
          <div className="hidden lg:block absolute top-[64px] left-0 right-0 h-px bg-gradient-to-r from-transparent via-[var(--lum-gold)]/40 to-transparent" />

          <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
            {processSteps.map((s, i) => (
              <Reveal
                as="li"
                key={s.index}
                delay={Math.min(5, i + 1) as 1 | 2 | 3 | 4 | 5}
                className="lum-step group relative flex flex-col gap-5 cursor-pointer"
              >
                <div className="flex items-baseline justify-between">
                  <span className="lum-step-num font-display text-6xl md:text-[64px] text-[var(--lum-gold)] leading-none transition-all duration-500">
                    {s.index}
                  </span>
                  <span className="font-jp text-[11px] text-[var(--lum-cream)]/50 transition-colors duration-500 group-hover:text-[var(--lum-cream)]/80">
                    {s.duration}
                  </span>
                </div>

                {/* Dot on the line */}
                <div className="hidden lg:flex items-center gap-3">
                  <span className="lum-step-dot w-2 h-2 flex items-center justify-center rounded-full bg-[var(--lum-gold)] transition-all duration-500" />
                  <span className="flex-1 h-px bg-[var(--lum-cream)]/15 transition-colors duration-500 group-hover:bg-[var(--lum-gold)]/40" />
                </div>

                <div>
                  <div className="font-label text-[10px] text-[var(--lum-gold)]/80 mb-2 transition-all duration-500 group-hover:tracking-[0.4em]">
                    / {s.french}
                  </div>
                  <h5 className="font-jp text-2xl text-[var(--lum-cream)] mb-3 transition-transform duration-500 group-hover:translate-x-1 font-medium">
                    {s.title}
                  </h5>
                  <p className="font-jp text-base leading-[2.0] text-[var(--lum-cream)]/65">
                    {s.description}
                  </p>
                </div>

                {i < processSteps.length - 1 && (
                  <i className="lg:hidden ri-arrow-down-line text-[var(--lum-gold)]/50 text-xl w-5 h-5 flex items-center justify-center mx-auto mt-2 animate-pulse" />
                )}
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}